import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters(['activeUser', 'activeOrganization', 'activeSystem']),
        systemDetailLinks() {
            if (!this.activeSystem) return;

            const links = [
                {
                    icon: 'common-system',
                    to: {
                        name: 'system-detail',
                        params: { id: this.activeSystem.id },
                    },
                    label: this.activeSystem.name || this.activeSystem.serial_number,
                    activePath: '/systems/.+',
                },
                {
                    to: {
                        name: 'system-hydraulics',
                        params: { id: this.activeSystem.id },
                    },
                    label: this.$t('navigation.systems.hydraulics'),
                    activePath: '/systems/.+/hydraulics',
                    visible: this.activeSystem.hydraulics_visualization_url !== undefined && this.activeSystem.hydraulics_visualization_url !== null,
                },
                {
                    to: {
                        name: 'system-parameters',
                        params: { id: this.activeSystem.id },
                    },
                    label: this.$t('navigation.systems.parameters'),
                    activePath: '/systems/.+/parameters',
                },
                {
                    to: {
                        name: 'system-parameter-logs',
                        params: { id: this.activeSystem.id },
                    },
                    label: this.$t('navigation.systems.parameter_logs'),
                    activePath: '/systems/.+/parameter-logs',
                    visible: this.$can('see Full Extended Navigation', this.activeSystem),
                },
                {
                    to: {
                        name: 'system-progression',
                        params: { id: this.activeSystem.id },
                    },
                    label: this.$t('navigation.systems.progression'),
                    activePath: '/systems/.+/progression',
                    visible: this.$can('see Full Extended Navigation', this.activeSystem),
                },
                {
                    to: {
                        name: 'system-logs',
                        params: { id: this.activeSystem.id },
                    },
                    label: this.$t('navigation.systems.logs'),
                    activePath: '/systems/.+/logs',
                    visible: this.$can('see Full Extended Navigation', this.activeSystem),
                },
            ];

            return links.filter(link => link.visible === true || link.visible === undefined);
        },
        systemManagementLinks() {
            if (!this.activeSystem) return;
            const links = [
                {
                    to: {
                        name: 'system-management',
                        params: { id: this.activeSystem.id },
                    },
                    label: this.$t('system.navigation.overview'),
                    isActive: this.$router.history.current.name === 'system-management',
                },
                {
                    to: {
                        name: 'settings',
                        params: { id: this.activeSystem.id },
                    },
                    label: this.$t('system.navigation.settings'),
                    isActive: this.$router.history.current.name === 'settings',
                    visible: this.$can('see System settings', this.activeSystem),
                },
                {
                    to: {
                        name: 'webserver-update',
                        params: { id: this.activeSystem.id },
                    },
                    label: this.$t('system.navigation.webserver'),
                    isActive: this.$router.history.current.name === 'webserver-update',
                    visible: this.$can('see System update', this.activeSystem),
                },
                {
                    to: {
                        name: 'data-recordings',
                        params: { id: this.activeSystem.id },
                    },
                    label: this.$t('system.navigation.recording'),
                    isActive: this.$router.history.current.name === 'data-recordings',
                    visible: this.$can('see System recorder', this.activeSystem),
                },
            ];

            return links.filter(link => link.visible === true || link.visible === undefined);
        },
        allSystemLinks() {
            if (!this.activeSystem) return;
            return [this.systemDetailLinks[0], ...this.systemManagementLinks, ...this.systemDetailLinks.slice(1)];
        },
        organizationDetailLinks() {
            if (!this.activeOrganization) return;
            const links = [
                {
                    icon: 'common-partner',
                    to: {
                        name: 'organization-management',
                        params: { id: this.activeOrganization.id },
                    },
                    label: this.activeOrganization.name,
                    activePath: '/organization/.+',
                },
                {
                    to: {
                        name: 'organization-persons',
                        params: { id: this.activeOrganization.id },
                    },
                    label: this.$t('organizations.persons'),
                    activePath: '/organization/.+/persons',
                    visible: this.$can('see', 'Organization persons'),
                },
                {
                    to: {
                        name: 'organization-system-service',
                        params: { id: this.activeOrganization.id },
                    },
                    label: this.$t('organizations.serviced_systems'),
                    activePath: '/organization/.+/system-service',
                },
                {
                    to: {
                        name: 'organization-system-operate',
                        params: { id: this.activeOrganization.id },
                    },
                    label: this.$t('organizations.operated_systems'),
                    activePath: '/organization/.+/system-operate',
                },
            ];

            return links.filter(link => link.visible === true || link.visible === undefined);
        },
        userDetailLinks() {
            if (!this.activeUser) return;
            return [
                {
                    icon: 'common-user',
                    to: {
                        name: 'user-management',
                        params: { id: this.activeUser.id },
                    },
                    label: this.activeUser.name,
                    activePath: '/user/.+',
                },
                {
                    to: {
                        name: 'user-systems',
                        params: { id: this.activeUser.id },
                    },
                    label: this.$t('users.userSystems'),
                    activePath: '/user/.+/systems',
                },
                {
                    to: {
                        name: 'user-changelog',
                        params: { id: this.activeUser.id },
                    },
                    label: this.$t('users.userChangelog'),
                    activePath: '/user/.+/changelog',
                },
            ];
        },
    },
};
